import { useContext } from "react";
import { ThemeContext, type ThemeContextValue } from "@/lib/theme/themeContext";

export type { ThemeContextValue };

export function useThemeContext(): ThemeContextValue {
  return useContext(ThemeContext);
}
